export default {
    nodes: [],
    inputs: {},
    lastItemId: null,
    models: {},
    flowEndTrigger: null
}